import React from 'react'
import HotelDetailsForm from './HotelDetailsForm'
import HotelProgressBar from './HotelProgressBar'
import HotelOwnerDetailsForm from './HotelOwnerDetailsForm';
import HotelFeatureForm from './HotelFeatureForm';
import HotelUploadsForm from './HotelUploadsForm';
import HotelSummaryForm from './HotelSummaryForm';
import { AdsCategory, AdsStepType } from '../../../../constants';
import { setFormDataAction, setStepAction } from '../../../../redux/action/multiStepFormAction';
import { useDispatch, useSelector } from 'react-redux';

function HotelCommon() {
  const currentStep = useSelector(state => state.multiStepForm.step);
  const dispatch = useDispatch();

  function setFormFilledData(data, type) {
    dispatch(setFormDataAction({
      type: AdsCategory.hotel,
      data: { [type]: data }
    }))
  }

  function setStep(step) {
    console.log("PASSED Step FROM CHILD IS ==" + step);
    dispatch(setStepAction(step));
  }

  const getForm = () => {
    switch (currentStep) {
      case 1:
        return <HotelDetailsForm
          type={AdsStepType.organization}
          setStep={setStep}
          setFormFilledData={setFormFilledData} />
      case 2:
        return <HotelOwnerDetailsForm
          type={AdsStepType.owner}
          setStep={setStep}
          setFormFilledData={setFormFilledData} />
      case 3:
        return <HotelFeatureForm
          type={AdsStepType.features}
          setStep={setStep}
          setFormFilledData={setFormFilledData} />
      case 4:
        return <HotelUploadsForm
          type={AdsStepType.uploads}
          setStep={setStep}
          setFormFilledData={setFormFilledData} />
      case 5:
        return <HotelSummaryForm
          setStep={setStep}
        />
      default:
        return null;
    }
  }
  return (
    <div>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12 col-md-12 col-sm-12'>
            <div style={{ marginLeft: '15%' }}>
              <HotelProgressBar stepNo={currentStep} />
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-lg-8 col-md-8 mx-auto' style={{ backgroundColor: '#fff', marginTop: '1%' }}>
            {
              getForm()
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default HotelCommon
